import React, { useCallback, useEffect, useState } from 'react';
import useService from '@/lib/hooks/useService';
import client from '@/lib/feathers';
import AppPreview from './AppPreview';
import ButtonsPreview from './ButtonsPreview';
import ColorSettingForm from './ColorSettingForm';
import styles from './index.module.scss';
import { fallbackTheme } from './fallbackTheme';
import type { ThemeSchema, Theme } from './themeSchema';

const StyleSetting = () => {
  const [data] = useService<ThemeSchema>({
    collectionName: 'communityAppTheme',
  });

  const [themes, setThemes] = useState<Theme[]>([]);
  const [selectedTheme, setSelectedTheme] = useState<Theme>(fallbackTheme);

  const formatThemesData = (dataArr: ThemeSchema[]): Theme[] => {
    const formattedDataArr = dataArr.map((dataObj) => {
      const {
        name,
        color: { bg, system, button },
        icons: { navbar, logo },
        official,
      } = dataObj;
      const {
        primary: { gradient1, gradient2, text: primaryText },
        secondary: { bg: secondaryBg, text: secondaryText },
      } = button;

      return {
        name: name,
        bgColor: bg,
        sysColor: system,
        primaryBtnGradientStart: gradient1,
        primaryBtnGradientEnd: gradient2,
        primaryBtnTxt: primaryText,
        secondaryBtnBg: secondaryBg,
        secondaryBtnTxt: secondaryText,
        iconsName: navbar.name,
        logoUrl: logo.url,
        isUploaded: false,
        official,
      };
    });

    return formattedDataArr;
  };

  const getCommunityTheme = useCallback(async (themes: Theme[]) => {
    const res = await client.service('communityData').find();
    const communityTheme = themes.find(
      (theme) => theme.name === res.data[0].themeName
    );
    if (communityTheme) {
      setSelectedTheme(communityTheme);
    }
  }, []);

  useEffect(() => {
    const formattedArr = formatThemesData(data);
    getCommunityTheme(formattedArr);
    setThemes(formattedArr);
  }, [data, getCommunityTheme]);

  const updateThemes = (newThemes: Theme[]) => {
    setThemes(newThemes);
  };

  const updateSelectedTheme = (newTheme: Theme) => {
    setSelectedTheme(newTheme);
  };

  const ButtonsPreviewProps = {
    primaryBtnGradientStart: selectedTheme.primaryBtnGradientStart,
    primaryBtnGradientEnd: selectedTheme.primaryBtnGradientEnd,
    primaryBtnTxt: selectedTheme.primaryBtnTxt,
    secondaryBtnBg: selectedTheme.secondaryBtnBg,
    secondaryBtnTxt: selectedTheme.secondaryBtnTxt,
  };

  return (
    <div className={styles.container}>
      <ColorSettingForm
        themes={themes}
        selectedTheme={selectedTheme}
        updateThemes={updateThemes}
        updateSelectedTheme={updateSelectedTheme}
      />
      <div className={styles.buttonsWrapper}>
        <ButtonsPreview ButtonsPreviewProps={ButtonsPreviewProps} />
      </div>
      <AppPreview
        bgColor={selectedTheme.bgColor}
        sysColor={selectedTheme.sysColor}
        logoUrl={selectedTheme.logoUrl}
      />
    </div>
  );
};
export default StyleSetting;
